import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';

import server from 'server/serverController2';

import Presenter from 'components/presenters/task/FriendTaskListHeader';
import BottomModal from 'components/presenters/modal/BottomModal';

export default function FriendTaskListHeader({userData, friendsCheck, friendsunCheck, friendDelSubmit, datafrSubmit, setBottomModalVisible, setBottomModalDataList}) {

    const handleFriendDelete = () => {
        friendDelSubmit();
    }

    const handleFriendRequest = () => {
        friendsCheck();
    }

    const handleRequestCancel = () => {
        friendsunCheck();
    }

    const handleAcceptFriend = () => {
        datafrSubmit(userData.user.no);
    }

    const handleOpenBottomModal = () => {
        const bottomModalOptions = [];

        if(userData.is_friend)
        {
            bottomModalOptions.push({ type:'callback', text: '친구취소', callback: () => handleFriendDelete(), style: {color: '#DE0000'}})
        }
        else if(!userData.is_friend_requested_received && userData.is_friend_requested)
        {
            bottomModalOptions.push({ type:'callback', text: '요청취소', callback: () => handleRequestCancel(), style: {color: '#DE0000'}})
        }
        setBottomModalDataList(bottomModalOptions);
        setBottomModalVisible(true);
    }

    return (
        <>
            <Presenter 
                userData={userData}
                onFriendRequest={handleFriendRequest}
                onOpenBottomModal={handleOpenBottomModal}
                onAcceptFriend={handleAcceptFriend}
            />
        </>
    )
}